import React, { Component } from "react";
import Validator from "util/form-validator";
import Field from "visual-components/util/inputs/field";

const validations = {
  ctaMessageText: [Validator.required],
  ctaURL: [Validator.required],
  ctaActionText: [Validator.required],
};

export default class CtaButton extends Component {
  render() {
    return (
      <div>
        <Field
          {...this.props}
          attrName="ctaMessageText"
          label="Headline Message"
          placeholder="Headline Message"
          validations={validations.ctaMessageText}
        />
        <Field
          {...this.props}
          attrName="ctaUrl"
          label="Custom CTA Link"
          placeholder="http://www.companysite.com/promo"
          validations={validations.ctaURL}
        />
        <Field
          {...this.props}
          attrName="ctaActionText"
          label="Button Text"
          placeholder="Button Text"
          validations={validations.ctaActionText}
        />
      </div>
    );
  }
}
